type Props = {
  width?: number
  height?: number
  fill?: string
  ariaLabel?: string
}

export function TwitterIcon({
  width = 24,
  height = 20,
  fill = '#ffffff',
  ariaLabel = 'Twitter',
}: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={ariaLabel}
    >
      <path
        d="M11.9027 8.46864L19.3482 0H17.5838L11.119 7.3532L5.95547 0H0L7.8082 11.1193L0 20H1.76443L8.59152 12.2348L14.0445 20H20L11.9027 8.46864ZM9.48608 11.2173L8.69495 10.1101L2.40018 1.29968H5.11025L10.1902 8.40994L10.9813 9.51718L17.5847 18.7594H14.8746L9.48608 11.2173Z"
        fill={fill}
      />
    </svg>
  )
}
